import { render, staticRenderFns } from "./background.vue?vue&type=template&id=e83b377a&lang=pug"
import script from "./background.vue?vue&type=script&lang=js"
export * from "./background.vue?vue&type=script&lang=js"
import style0 from "./background.vue?vue&type=style&index=0&id=e83b377a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports